import React, { useEffect, useMemo } from 'react'
import { faSlidersSolid } from '@/lib/fa'
import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'
import StageHeader from '@/modules/drivers/forms/shared/StageHeader'
import { FieldsetSelect } from '@/modules/settings/components/FieldsetSelect'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useRaportForm } from '../../context/RaportFormContext'

const EVENT_FIELDS = [
  { field: 'showActiveness', label: 'printout.driver-activeness-active-periods' },
  { field: 'showTimesheet', label: 'printout.driver-activeness-timesheet' },
  { field: 'showBusinessTrip', label: 'printout.driver-activeness-business-trip' },
  { field: 'showPrintout', label: 'printout.driver-activeness-printouts' },
]

const DriverActiveness = () => {
  const { data, setData } = useRaportForm()
  const { t } = useLocalize()

  const now = useMemo(() => new Date(), [])
  const years = [now.getFullYear(), now.getFullYear() - 1, now.getFullYear() - 2]

  useEffect(() => {
    setData((prev: any) => ({
      selectedYear: now.getFullYear(),
      selectedMonth: now.getMonth() + 1,
      showActiveness: true,
      showTimesheet: true,
      showBusinessTrip: true,
      showPrintout: true,
      ...prev,
    }))
  }, [])

  const setNumber = (field: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
    setData({ ...data, [field]: Number(e.target.value) })

  return (
    <div className="tw-flex-1 tw-space-y-4 tw-overflow-auto tw-p-4 tw-pr-8">
      <div className="tw-flex tw-items-start">
        <StageHeader title={t('printout.data')} textSize="sm" icon={faSlidersSolid} />
        <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-1 sm:tw-min-w-[400px]">
          <div className="tw-flex tw-gap-3">
            <FieldsetSelect
              label={t('printout.driver-activeness-month')}
              value={String(data?.selectedMonth ?? now.getMonth() + 1)}
              name="selectedMonth"
              onChange={setNumber('selectedMonth')}
              searchEnabled={false}
              options={Array.from({ length: 12 }, (_, i) => ({
                value: String(i + 1),
                label: String(i + 1).padStart(2, '0'),
              }))}
            />
            <FieldsetSelect
              label={t('printout.driver-activeness-year')}
              value={String(data?.selectedYear ?? now.getFullYear())}
              name="selectedYear"
              onChange={setNumber('selectedYear')}
              searchEnabled={false}
              options={years.map((year) => ({ value: String(year), label: String(year) }))}
            />
          </div>
          {EVENT_FIELDS.map(({ field, label }) => (
            <CheckboxWithLabelField
              key={field}
              field={field}
              data={data}
              setData={setData}
              label={t(label)}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default DriverActiveness
